import { useDispatch, useSelector } from 'react-redux';
import styles from './ProjectsYearFilter.module.scss';
import { setYearFilterProjects } from '../../../../../redux/Reducers/projectsReducer';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectsYearFilter = () => {
  const dispatch = useDispatch();
  const filterYear = useSelector((state) => state.projects.filterYearProjects);
  const projectList = useSelector((state) => state.projects.projects);
  const years = [...new Set(projectList.map((proj) => new Date(proj.year).getFullYear()))].sort((a, b) => b - a);

  const handleSetYearFilter = (year) => {
    dispatch(setYearFilterProjects(year));
  };

  if (years.length === 0 || years.length === 1) {
    return <></>;
  }

  return (
    <div className={classnames(isMobile ? [styles.box, styles.mobile] : [styles.box])}>
      <h3 className={styles.title}>Архив</h3>
      <button
        onClick={() => handleSetYearFilter(null)}
        className={classnames(filterYear === null ? [styles.allYears, styles.active] : [styles.allYears])}>
        Все года
      </button>

      {years.map((year) => {
        return (
          <button
            key={year}
            onClick={() => handleSetYearFilter(year)}
            className={classnames(filterYear === year ? [styles.yearItem, styles.active] : [styles.yearItem])}>
            {year}
          </button>
        );
      })}
    </div>
  );
};

export default ProjectsYearFilter;
